import InputFiled from "../common/inputFiled";
import ButtonIcon from "../common/buttonIcon";
import { useState } from "react";

const BoxShareLink = (props: any) => {

  let url = props.url ?? "";
  let label = props.label ?? "";

  const [activeCopy, setActiveCopy] = useState(false)
  const goToPreview = () => {
    window.open(
      url,
      '_blank',
      'noopener,noreferrer'
    );
  }

  const copyUrl = () => {
    var tempInput = document.createElement("input");
    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    navigator.clipboard.writeText(url);
    document.body.removeChild(tempInput);
    setActiveCopy(true);
    setTimeout(() => {
      setActiveCopy(false);
    }, 1000)
  }

  return (
    <div className="row m-0 boxShareLink pb-3">
      <div className="col-12">
        <p><b>{label}</b></p>
      </div>
      <div className="col-lg-8">
        <InputFiled value={url} readOnly={true} />
      </div>
      <div className="col-lg-4">
        <ButtonIcon disabled={activeCopy} active={activeCopy} handleClick={() => { copyUrl() }} icon={((activeCopy) ? "done" : "content_copy")} />
        <ButtonIcon handleClick={() => { goToPreview() }} icon={"preview"} />
      </div>
    </div>
  )
}

export default BoxShareLink

